<div class="d-flex flex-column fixed-width">
    <canvas #canvas class="fixed-width"></canvas>
    <div class="btn-group" role="group" aria-label="Basic example">
        <button class="btn btn-primary" (click)="onClear()">Löschen</button>
        <button class="btn btn-primary" [disabled]="!modelLoaded"
            (click)="onSubmit()">{{modelLoaded ? 'Auswerten' : 'Kein Modell geladen'}}</button>
      </div>
</div>